import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getPriceString } from 'site-modules/shared/utils/price-utils';
import { VdpModule } from 'site-modules/shared/components/inventory/vdp-module/vdp-module';
import { IncentivesCardListOptions } from 'site-modules/shared/components/incentives/card-list-options/incentives-card-list-options';
import { RestrictionItem } from 'site-modules/shared/components/incentives/restriction-item/restriction-item';
import { ReportSmthWrongLink } from 'site-modules/shared/components/report-smth-wrong-link/report-smth-wrong-link';
import { SupportCopyShop3527 } from 'site-modules/shared/components/incentives/incentives-modal-item/support-copy-shop-3527';
import { SupportCopy } from 'site-modules/shared/components/incentives/incentives-modal-item/support-copy';

export function IncentivesModalItem({
  description = '',
  grantor = '',
  endDate = '',
  updateDate = '',
  restrictions = '',
  subtype = '',
  rebateAmount = 0,
  isCollapsedRestrictions = false,
  modalParamsData = {},
  primary = false,
  compatibleIncentiveIds = [],
  programType = '',
  showSupportCopy = false,
  rebateOverridesByEligibility = [],
  subtypeId,
  transactionTypeFilter = '',
  isShop3527EnableWizard = false,
  isCompletedWizardFlow = false,
}) {
  const listItems = [
    { label: 'Program Provider', value: grantor || '' },
    { label: 'Expiration Date', value: endDate },
    { label: 'Last Updated', value: updateDate },
  ];
  return (
    <VdpModule className="bg-white">
      {subtype && (
        <div
          className={classnames('d-flex justify-content-between size-16 fw-bold', {
            'mb-0_25': !!description,
            'mb-1': !description,
          })}
        >
          <div>
            <span className="text-cool-gray-10 me-1">{subtype}</span>
            {showSupportCopy && isShop3527EnableWizard && (
              <SupportCopyShop3527
                transactionTypeFilter={transactionTypeFilter}
                isCompletedWizardFlow={isCompletedWizardFlow}
                primary={primary}
                compatibleIncentiveIds={compatibleIncentiveIds}
                rebateOverridesByEligibility={rebateOverridesByEligibility}
                subtypeId={subtypeId}
              />
            )}
            {showSupportCopy && !isShop3527EnableWizard && (
              <SupportCopy
                primary={primary}
                compatibleIncentiveIds={compatibleIncentiveIds}
                programType={programType}
              />
            )}
          </div>

          {!!rebateAmount && <span className="text-green-40 mb-1">{getPriceString(rebateAmount)}</span>}
        </div>
      )}

      {!!description && <div className="size-16 text-cool-gray-30">{description}</div>}
      <IncentivesCardListOptions listItems={listItems} />
      <RestrictionItem restrictions={restrictions} isCollapsed={isCollapsedRestrictions} />
      <div className="mt-1 small">
        <ReportSmthWrongLink
          linkClassName="align-middle text-decoration-none-hover text-primary-darker"
          iconClassName="icon-notification2 me-0_5 text-gray-dark"
          title="Report a problem"
          form="see-something-wrong-with-this-rebate"
          trackingValue="report a problem"
          trackingId="other_site_clickout"
          paramsData={modalParamsData}
        />
      </div>
    </VdpModule>
  );
}

IncentivesModalItem.propTypes = {
  description: PropTypes.string,
  grantor: PropTypes.string,
  endDate: PropTypes.string,
  updateDate: PropTypes.string,
  restrictions: PropTypes.string,
  subtype: PropTypes.string,
  rebateAmount: PropTypes.number,
  isCollapsedRestrictions: PropTypes.bool,
  modalParamsData: PropTypes.shape({
    make: PropTypes.string,
    model: PropTypes.string,
    incentiveId: PropTypes.string,
    sessionId: PropTypes.string,
  }),
  primary: PropTypes.bool,
  compatibleIncentiveIds: PropTypes.arrayOf(PropTypes.string),
  programType: PropTypes.string,
  showSupportCopy: PropTypes.bool,
  rebateOverridesByEligibility: PropTypes.arrayOf(PropTypes.shape({})),
  subtypeId: PropTypes.number,
  transactionTypeFilter: PropTypes.string,
  isShop3527EnableWizard: PropTypes.bool,
  isCompletedWizardFlow: PropTypes.bool,
};
